export default __webpack_public_path__ + "static/media/trackingContainers2.03fca1d2.jpg";